export const dimensions = {
  toolbarHeight: '64px',
  leftSideNavigationWidth: '255px'
};
